import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter as Router
} from "react-router-dom";
import {
    createMuiTheme,
    ThemeProvider,
} from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#1E124F'
        },
        secondary: {
            main: '#FBFBFB'
        }
    },
    typography: {
        fontFamily: [
            'Open Sans',
            'sans-serif'
        ].join(','),
    },
    overrides: {
        MuiButton: {
            root: {
                height: '35px',
                fontWeight: 'bold',
            },
            label: {
                textTransform: 'capitalize',
                fontSize: '15px'
            },
            contained: {
                boxShadow: 'none'
            }
        },
        MuiOutlinedInput: {
            root: {
                height: '35px',
                background: '#FBFBFB'
            },
            input: {
                padding: '7px 14px'
            }
        },
        MuiIconButton: {
            root: {
                color: '#FBFBFB'
            }
        },
        MuiChip: {
            label: {
                fontWeight: 'bold'
            }
        }
    }
})

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <ThemeProvider theme={theme}>
                <App/>
            </ThemeProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
